/**
 * Remove one account from MSAL browser storage without an end-session redirect.
 * @azure/msal-browser v3.27+ uses clearCache({ account }) instead of removeAccount.
 *
 * @param {import('@azure/msal-browser').PublicClientApplication} instance
 * @param {import('@azure/msal-browser').AccountInfo} account
 * @returns {Promise<void>}
 */
export async function removeAccountFromMsalCache(instance, account) {
  if (!instance || !account) {
    return;
  }
  await instance.clearCache({ account });
}
